import React from "react";
import MainLayout from "../../layout/MainLayout";
import DefaultHeader from "../../layout/Header/DefaultHeader";
import CancerTwoBuFooter from "../../layout/Footer/CancerTwoBuFooter";
import FormList from "./FormList";

const BreastSubForm = ({
  score,
  onPageChange,
  onChange,
  onRangeChange,
  onYearChang,
  onPageMove,
  inputElGap,
}) => {
  return (
    <MainLayout
      header={<DefaultHeader cancer="유방암" />}
      footer={
        <CancerTwoBuFooter
          name1="뒤로"
          name2="위험도 계산"
          onClick1={onPageChange}
          onClick2={onPageMove}
        />
      }
    >
      <FormList
        score={score}
        onChange={onChange}
        onRangeChange={onRangeChange}
        onYearChang={onYearChang}
        inputElGap={inputElGap}
      />
    </MainLayout>
  );
};

export default BreastSubForm;
